import { React, useRef, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import StyledRadio from '../StyledExtensions/StyledRadio'
import ActiveDonations from '../Modals/ActiveDonations';


export default function PaymentOptions(props) {

    const [paymentType, setPaymentType] = useState(props.pickupRequest.CustomerPaymentMethod === undefined ? '' : props.pickupRequest.CustomerPaymentMethod);
    const [selectedDonation, setSelectedDonation] = useState(props.pickupRequest.Donation === undefined ? null : props.pickupRequest.Donation);
    const [showActiveDonationsDialog, setShowActiveDonationsDialog] = useState(false);

    function paymentTypeSelected(type) {
        if (type === 'Donate') {
            setShowActiveDonationsDialog(true);
        }
        else {
            setSelectedDonation(null);
            setPaymentType(type)
        }
        if (props.onChanged !== undefined) {
            // used in the Customer Order update
            if (type !== 'Donate') {
                props.onChanged(type);
            }
        }
    }

    function donationSelected(donation) {
        setShowActiveDonationsDialog(false);
        setSelectedDonation(donation);
        setPaymentType('Donate')
        if (props.onChanged !== undefined) {
            // used in the Customer Order update
            props.onChanged(donation.Tag);
        }
    }

    return (
        <div style={{ maxWidth: '450px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={props.onChanged === undefined ? styles.cardHeader : ''}>How would you like to be paid?</div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }} onClick={() => paymentTypeSelected('Digital Check')}>
                {<StyledRadio checked={paymentType === 'Digital Check'} style={{ alignSelf: 'center' }} />}
                <div className='PaymentOptionItem' style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src='images/Payout.png' style={{ width: '43px', alignSelf: 'center' }} />
                    <div style={{ alignSelf: 'center', marginLeft: '10px' }}>Digital Check sent to email</div>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }} onClick={() => paymentTypeSelected('Mailed Check')}>
                {<StyledRadio checked={paymentType === 'Mailed Check'} style={{ alignSelf: 'center' }} />}
                <div className='PaymentOptionItem' style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src='images/MailedCheck.png' style={{ width: '43px', alignSelf: 'center' }} />
                    <div style={{ alignSelf: 'center', marginLeft:'10px' }}>Physical check mailed to your address</div>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }} onClick={() => paymentTypeSelected('Donate')}>
                {<StyledRadio checked={paymentType === 'Donate'} style={{ alignSelf: 'flex-start', paddingTop:'0px' }} />}
                <div className='PaymentOptionItem' style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src='images/DonateIcon.png' style={{ width: '43px', alignSelf: 'flex-start', paddingTop: '0px' }} />
                    <div style={{ alignSelf: 'flex-start', marginLeft: '10px', textAlign:'left' }}>
                        <div>Donate to a local non-profit, business or fundraiser</div>
                        <div style={{ fontStyle: 'italic' }}>We do not provide donation receipts at this time</div>
                        {
                            selectedDonation === null ? null :
                                <div style={{fontWeight:'bold', fontSize:'16px'} }> {selectedDonation.DonationTitle.replace('&#39;', '\'')}</div>
                        }
                    </div>

                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }} onClick={() => paymentTypeSelected('Tip All')}>
                {<StyledRadio checked={paymentType === 'Tip All'} style={{ alignSelf: 'center' }} />}
                <div className='PaymentOptionItem' style={{ display: 'flex', flexDirection: 'row'}}>
                    
                    <div style={{ alignSelf: 'center', marginLeft: '10px' }}>Tip my proceeds to my recycler</div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
               
                {(props.onBack !== undefined) ?
                    <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                        <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                        <Button variant={paymentType !== '' ? "contained" : "outlined"} color="sipzeeGreen" disabled={paymentType == ''} onClick={() => props.onNext(paymentType, selectedDonation)}>Next <KeyboardArrowRight /></Button>
                    </div>
                    :
                    null
                }
            </div>

            <ActiveDonations localZipcode={props.pickupData.ZipCodeInfo.Zipcode} isShown={showActiveDonationsDialog} onClose={() => setShowActiveDonationsDialog(false)} onSelected={donationSelected} zipcode={props.pickupData.ZipCodeInfo.Zipcode } />
        </div>
    );
}